<template>
  <div class="offer-confirm">
    <van-loading class="page-loading" v-if="pageLoading" color="#f60" />
    <div class="invalid" v-if="status === 'invalid'">
      <p>该Offer链接已失效，因此无法操作</p>
      <p>请联系HR进行处理</p>
      <div class="confirm">
        <van-button
          @click="goLogin"
          style="border-radius:.08rem"
          block
          color="#f60"
          type="default"
          >我知道了</van-button
        >
      </div>
    </div>
    <div class="phone-error" v-if="status === 'phoneError'">
      <p>该Offer链接对应候选人和当前登录用户信息不一致</p>
      <p>请更换手机号登录</p>
      <div class="confirm">
        <van-button
          @click="goLogin"
          style="border-radius:.08rem"
          block
          color="#f60"
          type="default"
          >我知道了</van-button
        >
      </div>
    </div>
    <div class="status-error" v-if="status === 'statusError'">
      <p>您的简历状态已更新，如需反馈信息</p>
      <p>请联系HR进行处理</p>
      <div class="confirm">
        <van-button
          @click="goLogin"
          style="border-radius:.08rem"
          block
          color="#f60"
          type="default"
          >我知道了</van-button
        >
      </div>
    </div>
    <div class="phone-success" v-if="status === 'success'">
      <p>提交成功</p>
    </div>
    <div class="normal" v-if="status === 'normal'">
      <van-form
        ref="uploadForm"
        class="offer-confirm-form"
        @submit="onSubmit"
        :scroll-to-error="true"
      >
        <div class="information">
          <div class="information-tit">确认OFFER</div>
          <van-field name="radio" label="是否接受">
            <template #input>
              <van-radio-group
                checked-color="#F60"
                v-model="accept"
                direction="horizontal"
              >
                <van-radio :name="1">接受OFFER</van-radio>
                <van-radio :name="0">拒绝OFFER</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div class="information" v-if="accept === 1">
          <div class="information-tit">个人信息</div>
          <p class="warning-info">
            请您仔细核对以下信息是否正确，并完善必填信息，保证入职信息的完整性和准确性！
          </p>
          <van-field
            readonly=""
            :value="formData.name"
            name="name"
            label="姓名"
            placeholder="请输入"
          />
          <van-field
            required
            v-model="formData.pinyin"
            name="pinyin"
            label="全拼"
            placeholder="请输入"
            :rules="[
              {
                required: true,
                message: '请输入全拼',
              },
            ]"
          />
          <van-field
            readonly=""
            :value="formData.phone"
            name="phone"
            label="联系电话"
            placeholder="请输入"
          />
          <van-field
            required
            v-model="formData.mail"
            name="mail"
            label="邮箱"
            placeholder="请输入"
            :rules="[
              {
                required: true,
                pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/i,
                message: '请输入合法邮箱',
              },
            ]"
          />
          <van-field
            required
            readonly
            clickable
            name="gender"
            :rules="[
              {
                required: true,
                message: '请选择性别',
              },
            ]"
            :value="formData.gender"
            right-icon="arrow"
            label="性别"
            placeholder="请选择性别"
            @click="changegender"
          />
          <van-field
            required
            readonly
            clickable
            name="nationality"
            :rules="[
              {
                required: true,
                message: '请选择国籍',
              },
            ]"
            :value="formData.nationality"
            right-icon="arrow"
            label="国籍"
            placeholder="请选择国籍"
            @click="changeNation"
          />
          <van-field
            required
            readonly
            clickable
            :rules="[
              {
                required: true,
                message: '请选择入境时间',
              },
            ]"
            right-icon="arrow"
            name="entryTimeStr"
            v-if="formData.nationality && formData.nationality !== '大陆'"
            :value="formData.entryTimeStr"
            label="入境时间"
            placeholder="请选择入境时间"
            @click="changeEntryTimeDate"
          />
          <van-field
            required
            readonly
            clickable
            name="credentialsType"
            :rules="[
              {
                required: true,
                message: '请选择证件类型',
              },
            ]"
            :value="formData.credentialsType"
            right-icon="arrow"
            label="证件类型"
            placeholder="请选择证件类型"
            @click="changeCredentialsType"
          />
          <van-field
            required
            v-model="formData.idCardNo"
            name="idCardNo"
            label="证件号"
            placeholder="请输入"
            :rules="[
              {
                required: true,
                message: '请输入证件号',
              },
            ]"
          />
          <van-field
            required
            v-model="formData.emergencyName"
            name="emergencyName"
            label="紧急联系人姓名"
            placeholder="请输入"
            :rules="[
              {
                required: true,
                message: '请输入紧急联系人姓名',
              },
            ]"
          />
          <van-field
            required
            v-model="formData.emergencyPhone"
            name="emergencyPhone"
            label="紧急联系人电话"
            placeholder="请输入"
            :rules="[
              {
                required: true,
                pattern: /^[1][0-9]{10}$/,
                message: '请输入合法手机号',
              },
            ]"
          />
        </div>
        <div class="education" v-if="accept === 1">
          <div class="education-tit">
            <span class="left">教育背景</span>
            <div class="right" @click="addEdu">
              <img src="@/assets/add-m.svg" alt="" />
              <span>添加教育背景</span>
            </div>
          </div>
          <div
            class="education-con"
            :key="index"
            v-for="(item, index) in formData.educations"
          >
            <van-field
              required
              readonly
              clickable
              right-icon="arrow"
              :name="`startDate${index}`"
              :value="item.startDate"
              label="开始时间"
              :rules="[
                {
                  required: true,
                  message: '请选择开始时间',
                },
              ]"
              placeholder="请选择开始时间"
              @click="changeDate(index, 'educations', 'startDate')"
            />

            <van-field
              required
              readonly
              clickable
              right-icon="arrow"
              :name="`endDate${index}`"
              :value="item.endDate"
              label="结束时间"
              :rules="[
                {
                  required: true,
                  message: '请选择结束时间',
                },
              ]"
              placeholder="请选择结束时间"
              @click="changeDate(index, 'educations', 'endDate')"
            />
            <van-field
              required
              readonly
              clickable
              :name="`degree${index}`"
              :value="item.degree"
              right-icon="arrow"
              label="学历"
              :rules="[
                {
                  required: true,
                  message: '请选择学历',
                },
              ]"
              placeholder="请选择学历"
              @click="changeDegrees(index)"
            />
            <van-field
              required
              :name="`university${index}`"
              v-model="item.university"
              label="学校"
              :rules="[
                {
                  required: true,
                  message: '请输入学校',
                },
              ]"
              placeholder="请输入"
            />
            <van-field
              required
              v-model="item.major"
              :name="`major${index}`"
              :rules="[
                {
                  required: true,
                  message: '请输入专业',
                },
              ]"
              label="专业"
              placeholder="请输入"
            />
            <div class="del-btn-warp">
              <van-button class="del-btn" @click="delEdu(index)" type="default"
                >删除</van-button
              >
            </div>
          </div>
        </div>

        <div class="works" v-if="accept === 1">
          <div class="works-tit">
            <span class="left">工作经历</span>
            <div class="right" @click="addWork">
              <img src="@/assets/add-m.svg" alt="" />
              <span>添加工作经历</span>
            </div>
          </div>
          <div
            class="works-con"
            :key="index"
            v-for="(item, index) in formData.works"
          >
            <van-field
              readonly
              clickable
              right-icon="arrow"
              :name="`startDate${index}`"
              :value="item.startDate"
              label="开始时间"
              placeholder="请选择开始时间"
              @click="changeDate(index, 'works', 'startDate')"
            />

            <van-field
              readonly
              clickable
              right-icon="arrow"
              :name="`endDate${index}`"
              :value="item.endDate"
              label="结束时间"
              placeholder="请选择结束时间"
              @click="changeDate(index, 'works', 'endDate')"
            />

            <van-field
              v-model="item.company"
              name="公司名称"
              label="公司名称"
              placeholder="请输入"
            />
            <van-field
              v-model="item.position"
              name="职位名称"
              label="职位名称"
              placeholder="请输入"
            />

            <van-field
              v-model="item.desc"
              type="textarea"
              :autosize="{
                maxHeight: 200,
                minHeight: 50,
              }"
              name="工作职责"
              label="工作职责"
              placeholder="请输入"
            />

            <div class="del-btn-warp">
              <van-button class="del-btn" @click="delWork(index)" type="default"
                >删除</van-button
              >
            </div>
          </div>
        </div>

        <div class="statement" v-if="accept === 1">
          <van-checkbox v-model="agree" checked-color="#f60"></van-checkbox>
          <span class="agree">我已同意</span>
          <span class="btn" @click="showStatement = true"
            >个人信息隐私保护申明</span
          >
        </div>

        <div class="sub">
          <van-button
            :loading="loading"
            :disabled="disabled"
            native-type="submit"
            style="border-radius:.08rem"
            color="#f60"
            block
            type="default"
            >提交</van-button
          >
        </div>
      </van-form>

      <van-calendar
        v-model="entryDateDialog"
        :min-date="new Date(1990, 0, 1)"
        :max-date="new Date(2030, 0, 1)"
        :default-date="entryDateDefault"
        @confirm="onEntryDateConfirm"
      />

      <van-popup v-model="commonDateDialog" round position="bottom">
        <van-datetime-picker
          v-model="commonDateDefault"
          type="date"
          title="选择年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="commonDateDialog = false"
          @confirm="onCommonDateConfirm"
        />
      </van-popup>

      <!-- 学历弹窗 -->
      <van-popup v-model="showDegreesPicker" round position="bottom">
        <van-picker
          show-toolbar
          :default-index="defaultIndex"
          :columns="degrees"
          @cancel="showDegreesPicker = false"
          @confirm="onDegreeConfirm"
        />
      </van-popup>
      <!-- 性别弹窗 -->
      <van-popup v-model="showGenderPicker" round position="bottom">
        <van-picker
          show-toolbar
          :default-index="genderDefaultIndex"
          :columns="genders"
          @cancel="showGenderPicker = false"
          @confirm="onGenderConfirm"
        />
      </van-popup>
      <!-- 国籍弹窗 -->
      <van-popup v-model="showNationalityPicker" round position="bottom">
        <van-picker
          show-toolbar
          :default-index="nationalityDefaultIndex"
          :columns="nationalities"
          @cancel="showNationalityPicker = false"
          @confirm="onNationalityConfirm"
        />
      </van-popup>
      <!-- 证件类型 -->
      <van-popup v-model="showCredentialsTypePicker" round position="bottom">
        <van-picker
          show-toolbar
          :default-index="CredentialsTypeDefaultIndex"
          :columns="credentialstypes"
          @cancel="showCredentialsTypePicker = false"
          @confirm="onCredentialsTypeConfirm"
        />
      </van-popup>
    </div>
    <GStatementM v-model="showStatement" />
  </div>
</template>
<script>
import Vue from 'vue'
import {
  RadioGroup,
  Radio,
  Form,
  Field,
  Calendar,
  Cell,
  Icon,
  Popup,
  Picker,
  Button,
  Checkbox,
  Toast,
  Loading,
  Dialog,
  DatetimePicker,
} from 'vant'
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Form)
Vue.use(Field)
Vue.use(Calendar)
Vue.use(Cell)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Dialog)
Vue.use(DatetimePicker)

import GStatementM from '@/components/GStatementM'
import { goLogin } from '@/service/request.js'
import { isValidDate, formatDate } from '@/service/utils.js'
import {
  checkOfferStatus,
  queryCredentialstype,
  queryNationality,
  querySrInfo,
  offerfeedback,
} from '@/service/offer'
export default {
  name: 'offer-confirm',
  components: { GStatementM },
  data() {
    return {
      offerId: '',
      pageLoading: false,
      loading: false,
      status: '',
      accept: 1,
      rangeDateDialog: false,
      index: '', //当前正在操作的序号
      defaultIndex: '',
      genderDefaultIndex: '',
      nationalityDefaultIndex: '',
      CredentialsTypeDefaultIndex: '',

      rangeDateDefault: [],
      entryDateDefault: new Date(),
      commonDateDefault: new Date(),
      showDegreesPicker: false,
      showGenderPicker: false,
      showNationalityPicker: false,
      entryDateDialog: false,
      commonDateDialog: false,
      showCredentialsTypePicker: false,

      degrees: ['博士', '硕士', '本科', '专科', '高中', '初中'],
      genders: ['男', '女'],
      minDate: new Date(1990, 0, 1),
      maxDate: new Date(2030, 0, 1),
      credentialstypes: [],
      nationalities: [],
      formData: {
        name: '',
        pinyin: '',
        phone: '',
        mail: '',
        gender: '',
        nationality: '',
        entryTime: '',
        entryTimeStr: '',
        credentialsType: '',
        idCardNo: '',
        emergencyName: '',
        emergencyPhone: '',
        educations: [],
        works: [],
      },
      agree: false,
      showStatement: false,
    }
  },
  computed: {
    disabled() {
      return !this.agree && this.accept === 1
    },
  },
  created() {
    this.start()
  },
  methods: {
    goLogin,
    async start() {
      this.getParams()
      this.checkOfferStatus()
    },
    getParams() {
      const { offerId } = this.$route.params
      this.offerId = offerId
    },
    async checkOfferStatus() {
      this.pageLoading = true
      const query = {
        id: this.offerId,
      }
      try {
        const status = await checkOfferStatus(query)
        const statusMap = new Map([
          [0, 'normal'],
          [1, 'phoneError'],
          [2, 'statusError'],
          [3, 'invalid'],
        ])
        this.status = statusMap.get(status)
        this.pageLoading = false
        if (this.status === 'normal') {
          this.queryCredentialstype()
          this.queryNationality()
          this.querySrInfo()
        }
        if (this.status === 'phoneError') {
          Dialog.alert({
            title: '',
            message:
              '该Offer链接对应候选人和当前登录用户信息不一致,确认后重新登录',
            theme: 'round-button',
            confirmButtonColor: '#F60',
          }).then(() => {
            this.goLogin()
          })
        }
      } catch (error) {
        this.status = 'statusError'
        this.pageLoading = false
        console.log('checkOfferStatus-error', error)
      }
    },
    /* 获取证件类型 */
    async queryCredentialstype() {
      this.credentialstypes = await queryCredentialstype()
    },
    /* 获取证件类型 */
    async queryNationality() {
      this.nationalities = await queryNationality()
    },
    /* 获取证件类型 */
    async querySrInfo() {
      const query = {
        id: this.offerId,
      }
      const formData = await querySrInfo(query)

      if (formData.entryTime) {
        const entryTimeObj = new Date(formData.entryTime)
        if (isValidDate(entryTimeObj)) {
          formData.entryTimeStr = formatDate(entryTimeObj, 2)
          formData.entryTime = formatDate(entryTimeObj, 1)
        }
      }

      if (formData && formData.educations) {
        formData.educations.forEach(item => {
          item.degree = item.degree === '未知' ? '' : item.degree
          const { startDate, endDate } = item
          if (startDate && endDate) {
            const startDateObj = new Date(startDate)
            const endDateObj = new Date(endDate)
            if (isValidDate(startDateObj) && isValidDate(endDateObj)) {
              item.startDate = `${formatDate(startDateObj, 1)}`
              item.endDate = `${formatDate(endDateObj, 1)}`
            } else {
              item.startDate = ''
              item.endDate = ''
            }
          } else {
            item.startDate = ''
            item.endDate = ''
          }
        })
      }

      if (formData && formData.works) {
        formData.works.forEach(item => {
          const { startDate, endDate } = item
          if (startDate && endDate) {
            const startDateObj = new Date(startDate)
            const endDateObj = new Date(endDate)
            if (isValidDate(startDateObj) && isValidDate(endDateObj)) {
              item.startDate = `${formatDate(startDateObj, 1)}`
              item.endDate = `${formatDate(endDateObj, 1)}`
            } else {
              item.startDate = ''
              item.endDate = ''
            }
          } else {
            item.startDate = ''
            item.endDate = ''
          }
        })
      }
      this.formData = formData
    },
    /* 选择性别 */
    changegender() {
      this.showGenderPicker = true
      const gender = this.formData.gender
      this.genderDefaultIndex =
        this.genders.indexOf(gender) === -1 ? 0 : this.genders.indexOf(gender)
    },
    onGenderConfirm(gender) {
      this.formData.gender = gender
      this.showGenderPicker = false
    },
    /* 选择国籍 */
    changeNation() {
      this.showNationalityPicker = true
      const nationality = this.formData.nationality
      this.nationalityDefaultIndex =
        this.nationalities.indexOf(nationality) === -1
          ? 0
          : this.nationalities.indexOf(nationality)
    },
    onNationalityConfirm(nationality) {
      this.formData.nationality = nationality
      this.showNationalityPicker = false
    },
    /* 选择入境时间 */
    changeEntryTimeDate() {
      this.entryDateDialog = true
      if (this.formData.entryTime) {
        this.entryDateDefault = new Date(this.formData.entryTime)
      } else {
        this.entryDateDefault = new Date()
      }
    },
    onEntryDateConfirm(date) {
      this.formData.entryTimeStr = formatDate(date, 2)
      this.formData.entryTime = formatDate(date, 1)
      this.entryDateDialog = false
    },
    /* 选择证件类型 */
    changeCredentialsType() {
      this.showCredentialsTypePicker = true
      const credentialsType = this.formData.credentialsType
      this.CredentialsTypeDefaultIndex =
        this.credentialstypes.indexOf(credentialsType) === -1
          ? 0
          : this.credentialstypes.indexOf(credentialsType)
    },
    onCredentialsTypeConfirm(credentialsType) {
      this.formData.credentialsType = credentialsType
      this.showCredentialsTypePicker = false
    },
    /* 选择学位 */
    changeDegrees(index) {
      this.index = index
      this.showDegreesPicker = true
      const degree = this.formData.educations[this.index].degree
      this.defaultIndex =
        this.degrees.indexOf(degree) === -1 ? 0 : this.degrees.indexOf(degree)
    },
    onDegreeConfirm(degree) {
      this.formData.educations[this.index].degree = degree
      this.showDegreesPicker = false
    },
    /* 选择学历 工作时间 */
    changeDate(index, type, dateType) {
      this.index = index
      this.type = type
      this.dateType = dateType
      const commonDateDefaultStr = this.formData[type][this.index][
        this.dateType
      ]
      this.commonDateDefault = commonDateDefaultStr
        ? new Date(commonDateDefaultStr)
        : new Date()
      this.commonDateDialog = true
    },
    onCommonDateConfirm(date) {
      if (this.dateType === 'startDate') {
        const endDate = this.formData[this.type][this.index].endDate
        if (endDate && new Date(endDate).valueOf() < new Date(date)) {
          Toast('开始时间必须小于结束时间')
          return
        }
      }
      if (this.dateType === 'endDate') {
        const startDate = this.formData[this.type][this.index].startDate
        if (startDate && new Date(startDate).valueOf() > new Date(date)) {
          Toast('结束时间必须大于开始时间')
          return
        }
      }
      this.commonDateDialog = false
      this.formData[this.type][this.index][this.dateType] = formatDate(date, 1)
    },
    /* 添加删除教育背景 */
    addEdu() {
      this.formData.educations.push({
        startDate: '',
        endDate: '',
        university: '',
        major: '',
        degree: '',
      })
    },
    delEdu(index) {
      this.formData.educations.splice(index, 1)
      return false
    },
    /* 添加删除工作经历 */
    addWork() {
      this.formData.works.push({
        startDate: '',
        endDate: '',
        company: '',
        position: '',
        desc: '',
      })
    },
    delWork(index) {
      this.formData.works.splice(index, 1)
      return false
    },
    /* 处理数据 */
    getQuery() {
      const formData = JSON.parse(JSON.stringify(this.formData))
      formData.educations.forEach(item => {
        item.degree = item.degree === '' ? '未知' : item.degree
      })
      delete formData.entryTimeStr
      const query = {
        id: this.offerId,
        accept: this.accept,
        userSrInfo: JSON.stringify(formData),
      }
      if (query.accept === 0) {
        delete query.userSrInfo
      }
      return query
    },
    async offerfeedback() {
      this.loading = true
      const body = this.getQuery()
      try {
        const res = await offerfeedback(body)
        if (res && res.code === 1) {
          this.status = 'success'
        } else {
          Toast.fail(res.msg || '提交失败')
        }
        this.loading = false
      } catch (error) {
        Toast.fail('提交失败')
        console.log('error', error)
        this.loading = false
      }
    },
    /* 提交 */
    onSubmit() {
      this.offerfeedback()
    },
  },
}
</script>
<style lang="less">
@media screen and(max-width: 320px) {
  .van-field__label {
    width: 70px;
  }
}
.font(@size:14px, @lh: 22px,@color: rgba(0, 0, 0, 0.45)) {
  font-size: @size;
  line-height: @lh;
  color: @color;
}

.offer-confirm {
  position: relative;
  height: 100%;
  max-width: 720px;
  margin: 0 auto;
  font-family: PingFang SC;
  overflow: hidden;
  .van-popup--bottom {
    max-width: 720px;
    left: auto;
  }
  .page-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -150%);
  }
  .invalid,
  .phone-error,
  .status-error,
  .phone-success {
    height: 100%;
    overflow: hidden;
    background-color: #fff;
    position: relative;
    p {
      text-align: center;
      &:first-child {
        padding-top: 1.3rem;
      }
    }
    .confirm {
      padding: 0 0.16rem;
      position: fixed;
      left: 0;
      bottom: 0.24rem;
      width: 100%;
    }
  }
  .normal {
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #e5e5e5;
    .offer-confirm-form {
      position: relative;
      min-height: 100%;
      padding-bottom: 1rem;
    }
    .van-cell {
      padding: 15px 16px;
    }
    .van-field__label {
      color: #999;
    }
    .warning-info {
      padding: 0 0.12rem;
      text-align: justify;
      color: #f60;
    }
    .information {
      overflow: hidden;
      .information-tit {
        .font(0.14rem, 0.2rem, #5c5c5c);
        padding: 0 0.12rem;
        margin: 0.24rem 0 0.08rem;
      }
    }
    .del-btn-warp {
      height: 0.48rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 0.16rem;
    }
    .del-btn {
      width: 0.64rem;
      height: 0.28rem;
      font-size: 0.14rem;
      padding: 0 0.16rem;
    }
    .education,
    .works {
      overflow: hidden;
      .education-tit,
      .works-tit {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.12rem;
        margin: 0.24rem 0 0.08rem;
        .left {
          .font(0.14rem, 0.2rem, #5c5c5c);
        }
        .right {
          display: flex;
          align-items: center;
          img {
            margin-right: 8px;
          }
          span {
            .font(0.16rem, 0.22rem, #f60);
          }
        }
      }
      .education-con,
      .works-con {
        background-color: #fff;
        margin-bottom: 0.1rem;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .van-checkbox__icon {
      font-size: 0.16rem;
    }
    .statement {
      display: flex;
      align-items: center;
      margin-top: 0.32rem;
      padding: 0 0.16rem;
      .agree {
        .font(0.14rem, 0.2rem, #9b9b9b);
        margin-left: 0.08rem;
        margin-right: 0.03rem;
      }
      .btn {
        .font(0.14rem, 0.2rem, #f60);
      }
    }
    .sub {
      padding: 0 0.16rem;
      position: absolute;
      left: 0;
      bottom: 0.24rem;
      width: 100%;
    }
  }
}
</style>
